"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderLabel = exports.StyledHeaderRow = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const styles_1 = require("../../styles");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledHeaderRow = (0, styled_1.default)('tr') `
  &:only-of-type,
  &:last-of-type {
    th {
      border-bottom: ${styles_1.borderStyle};
    }
  }
  &:not(:first-of-type) {
    th {
      border-top: 0;
    }
  }
`;
exports.StyledHeaderLabel = (0, styled_1.default)('span') `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
`;
//# sourceMappingURL=Header.styles.js.map